import { Pencil } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';
import {
  PowerEditorBasicInfoFields,
  type PowerEditorBasicInfoFieldsProps,
} from '@/components/painel/powers/PowerEditorBasicInfoFields';
import { PainelPermissionsDialogShell } from '@/components/painel/permissions/painel-role-visuals';
import {
  painelButtonPrimaryClass,
  painelModalCancelButtonClass,
} from '@/components/painel/painel-styles';
import { PainelRocketScroll } from '@/components/painel/PainelRocketScroll';
import { cn } from '@/lib/utils';

type PowerEditorBasicInfoModalProps = PowerEditorBasicInfoFieldsProps & {
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

export function PowerEditorBasicInfoModal({
  open,
  onOpenChange,
  ...fieldsProps
}: PowerEditorBasicInfoModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        showCloseButton={false}
        className="max-h-[90vh] max-w-3xl overflow-hidden border-0 bg-[#030023] p-0 shadow-none"
      >
        <DialogTitle className="sr-only">Editar informações básicas</DialogTitle>
        <PainelPermissionsDialogShell>
          <div className="shrink-0 border-b border-white/10 bg-blue-950/20 px-6 pb-5 pt-6 sm:px-8">
            <div className="flex items-start gap-4 pr-14">
              <span
                className={cn(
                  'inline-flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl',
                  'bg-gradient-to-br from-violet-500/25 to-violet-700/10 ring-1 ring-violet-400/35',
                  'shadow-[0_0_40px_-10px_rgba(139,92,246,0.35)]'
                )}
              >
                <Pencil className="h-6 w-6 text-violet-200" aria-hidden />
              </span>
              <div className="min-w-0 flex-1">
                <p className="font-inter text-[10px] font-bold uppercase tracking-[0.18em] text-sky-300/55">
                  Power
                </p>
                <h2 className="mt-1 font-poppins text-xl font-bold text-white sm:text-2xl">
                  Editar informações
                </h2>
                <p className="mt-1.5 font-inter text-sm leading-relaxed text-slate-400">
                  Metadados do power, preços sincronizados pela API e descrição do hero.
                </p>
              </div>
            </div>
          </div>

          <PainelRocketScroll
            className="max-h-[min(58vh,520px)] bg-[#030023]/30"
            viewportClassName="overscroll-contain px-6 py-5 sm:px-8"
          >
            <PowerEditorBasicInfoFields {...fieldsProps} />
          </PainelRocketScroll>

          <div className="shrink-0 flex flex-col-reverse gap-2 border-t border-white/10 bg-blue-950/40 px-6 py-4 sm:flex-row sm:justify-end sm:gap-3 sm:px-8">
            <Button
              type="button"
              variant="ghost"
              className={painelModalCancelButtonClass}
              onClick={() => onOpenChange(false)}
            >
              Cancelar
            </Button>
            <Button
              type="button"
              className={cn(painelButtonPrimaryClass, 'h-10 px-5')}
              onClick={() => onOpenChange(false)}
            >
              Salvar
            </Button>
          </div>
        </PainelPermissionsDialogShell>
      </DialogContent>
    </Dialog>
  );
}
